import React, { useEffect, useState } from "react";
// import getTeamMembersData from "../components/team-members/TeamMembersCardData.json";
import TeamMembersCard from "../components/team-members/TeamMembersCard";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import Layout from "../common/Layout";
import { Helmet } from "react-helmet";
import axios from "axios";

const TeamMembersPage = () => {
  // const data = getTeamMembersData.slice(0, 10);
  const [homeWeAre, setHomeWeAre] = useState(null);
  // console.log("employees", homeWeAre);
  const fetchHomeWeare = async () => {
    try {
      const response = await axios.get(
        "https://rss.fastwebforge.com/api/list/employees"
      );
      setHomeWeAre(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchHomeWeare();
  }, []);

  let heroSection = null;
  if (homeWeAre && homeWeAre.data && homeWeAre.data) {
    heroSection = homeWeAre.data;
  }

  // console.log(" Data:", heroSection);

  return (
    <>
      <Helmet>
        <title>Employees || RSS Security and Investigations Pty Ltd</title>
        <meta
          name="description"
          content="Securepress - Security Company React  Template"
        />
        <meta
          name="keywords"
          content="safety, bodyguard, cctv, emergency, Event Security, fire, investigation, investigator, officer, protection, security, Security Camera, Care, Parking  Security"
        />
      </Helmet>
      <Layout>
        <Breadcrumb
          pageTitle="Our Employees"
          rootPath="/"
          parentPath="Home"
          currentPath="Our Employees"
        />
        {/* Team Section Start */}
        <div className="team-sec pt-100 pb-70">
          <div className="container">
            <div className="row">
              {heroSection
                ? heroSection &&
                  heroSection.map((data, i) => (
                    <div key={i} className="col-xs-6 col-sm-4 col-md-4">
                      <TeamMembersCard key={data.id} data={data} />
                    </div>
                  ))
                : null}
              
            </div>
          </div>
        </div>
        {/* Team Section End */}
      </Layout>
    </>
  );
};

export default TeamMembersPage;
